module.exports = [{"fromPath":"/ati/who-we-are","isPermanent":true,"redirectInBrowser":true,"toPath":"/ati/who-we-are/our-advantage"},{"fromPath":"/ati/what-we-offer","isPermanent":true,"redirectInBrowser":true,"toPath":"/ati/what-we-offer/hotels-and-lodging"}]


//////////////////
// WEBPACK FOOTER
// ./.cache/redirects.json
// module id = 375
// module chunks = 231608221292675